import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import styles from './Home.module.css';

export default function Home() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [hovered, setHovered] = useState(null);

  const CHARACTERS = [
    { id: 'actor',     path: '/actor',     label: 'Actor',     sub: t('char_actor_sub'), number: '01', accent: '#c8a96e', bg: 'linear-gradient(135deg, #0a0a0a 0%, #1a1208 100%)' },
    { id: 'developer', path: '/developer', label: 'Developer', sub: t('char_dev_sub'),   number: '02', accent: '#00ff88', bg: 'linear-gradient(135deg, #020c06 0%, #001a0e 100%)' },
  ];

  const active = CHARACTERS.find(c => c.id === hovered);

  return (
    <div className={styles.root} style={{ background: active ? active.bg : 'linear-gradient(135deg, #080808 0%, #111 100%)' }}>
      <div className={styles.grain} />
      <div style={{ position: "fixed", top: "20px", right: "28px", zIndex: 200 }}>
        <LanguageSwitcher theme="dark" />
      </div>

      <header className={styles.header}>
        <p className={styles.eyebrow}>{t('home_eyebrow')}</p>
        <h1 className={styles.title}>Joaquin Montes</h1>
        <p className={styles.subtitle}>{t('home_subtitle')}</p>
      </header>

      <nav className={styles.nav}>
        {CHARACTERS.map((char) => (
          <button
            key={char.id}
            className={`${styles.item} ${hovered === char.id ? styles.itemActive : ''}`}
            style={{ '--accent': char.accent }}
            onMouseEnter={() => setHovered(char.id)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => navigate(char.path)}
          >
            <span className={styles.number}>{char.number}</span>
            <div className={styles.itemText}>
              <span className={styles.itemLabel}>{char.label}</span>
              <span className={styles.itemSub}>{char.sub}</span>
            </div>
            <span className={styles.arrow}>→</span>
          </button>
        ))}
      </nav>

      <footer className={styles.footer}><span>{t('home_footer')}</span></footer>
    </div>
  );
}
